import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';
import fetchList from './fetchList';

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {string} date
 */
function useDaily(accountType, date) {
  const { cb, key } = fetch(accountType, date);

  const { refetch, data, isSuccess } = useQuery(key, cb, {
    select: (_data) => _data.results,
    enabled: false,
  });

  return { refetch, data, isSuccess };
}

const defaultListResult = { next: false, results: [] };

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {import('./typedefs').Range} range
 */
function useRealizedDailyList(accountType, range) {
  const { cb, key } = fetchList(accountType, range);
  const {
    refetch,
    data = defaultListResult,
    isSuccess,
    isFetching,
  } = useQuery(key, cb, {
    select: (_data) => _data?.result ?? defaultListResult,
    enabled: Boolean(accountType && range),
    staleTime: 60 * 1000,
  });

  return { refetch, data, isSuccess, isFetching };
}

export default { useDaily, useRealizedDailyList };
